import { TAnswers, ISurvey, InvitationStatus } from "../surveyTypes";
import { isArray } from "util";
import questionTypeReducer from "./questionTypeReducer";
import indicatorReducer from "./indicatorReducer";
import questionReducer from "./questionReducer";

type SurveyReducerResult = {
  invitationStatus: InvitationStatus;
  answers: TAnswers;
  survey: ISurvey;
};

const surveyReducer = (data: any): SurveyReducerResult => {
  const invitationStatus: InvitationStatus = data.status;
  const survey: ISurvey = {};
  const answers: TAnswers = {};
  if (
    isArray(data.questions) &&
    invitationStatus === InvitationStatus.AWAITING
  ) {
    data.questions.forEach((question: any) => {
      answers[question.id] = {
        value: null,
        comment: null,
      };

      const questionGroupKey = String(question.indicator.id);
      const sectionKey = String(question.question_type.order);

      if (!(sectionKey in survey)) {
        survey[sectionKey] = {
          questionType: questionTypeReducer(question.question_type),
          questionGroups: {},
        };
      }
      const { questionGroups } = survey[sectionKey];
      if (!(questionGroupKey in questionGroups)) {
        questionGroups[questionGroupKey] = {
          indicator: indicatorReducer(question.indicator),
          questions: [],
        };
      }
      const { questions } = questionGroups[questionGroupKey];
      const q = questionReducer(question);
      questions.push(q);
    });
  }

  return {
    invitationStatus: invitationStatus,
    answers: answers,
    survey: survey,
  };
};

export default surveyReducer;
